import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import WpBlogHome from '../components/WpBlogHome'
import Helmet from 'react-helmet'
import { useLocation } from '@reach/router'
import { flattenTags } from '../utils'

const IndexPage = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const navBarData = data.contentfulNavigationBar
  const footerData = data.contentfulFooterV2
  const blogData = flattenTags(data.allWpPost.edges)
  const latestBlogPost = data.latestPost.edges[0].node
  const defaultdata = data.wp.generalSettings
  const tags = data.allWpTag.edges
  const siteLanguages = data.site.siteMetadata.languages
  const location = useLocation()
  const featuredPost =
    data.featuredPost.edges.length > 0
      ? data.featuredPost.edges[0]
      : blogData[0]
  const mutatedData =
    data.featuredPost.edges.length > 0
      ? blogData.filter(({ node }) => {
          return node.id !== data.featuredPost.edges[0].node.id
        })
      : blogData.slice(1)

  return (
    <Layout
      latestBlogPost={latestBlogPost}
      navBarData={navBarData}
      footerData={footerData}
      siteLanguages={siteLanguages}
      location={location}
    >
      <div style={{ background: '#fff' }}>
        <Helmet title={siteTitle} />
        <WpBlogHome
          data={mutatedData}
          tags={tags}
          defaultdata={defaultdata}
          location={location}
          featuredPost={featuredPost}
        />
      </div>
    </Layout>
  )
}

export const query = graphql`
  fragment previewCardQuery on WpPost {
    id
    isSticky
    title
    locale {
      locale
    }
    date(formatString: "MMMM D, YYYY")
    status
    slug
    excerpt
    featuredImage {
      node {
        localFile {
          childImageSharp {
            gatsbyImageData(width: 1344, height: 684, placeholder: BLURRED)
          }
          previewCardImage: childImageSharp {
            gatsbyImageData(width: 428, height: 217, placeholder: BLURRED)
          }
          publicURL
        }
        altText
      }
    }
    tags {
      nodes {
        name
        id
        slug
        locale {
          locale
        }
      }
    }
    author {
      node {
        slug
        userProfile {
          authorProfile {
            ... on WpAuthor {
              id
              title
              slug
              locale {
                locale
              }
            }
          }
        }
      }
    }
    postOptions {
      featuredOverlayAlignment
      metaDescription
      metaTitle
    }
  }

  fragment translatedPreviewCardQuery on WpPost {
    id
    isSticky
    title
    locale {
      locale
    }
    date(formatString: "MMMM D, YYYY")
    status
    slug
    excerpt
    tags {
      nodes {
        name
        id
        slug
        locale {
          locale
        }
      }
    }
    author {
      node {
        slug
        userProfile {
          authorProfile {
            ... on WpAuthor {
              id
              title
              slug
              locale {
                locale
              }
            }
          }
        }
      }
    }
    postOptions {
      featuredOverlayAlignment
      metaDescription
      metaTitle
    }
  }

  fragment homePageTag on WpTag {
    uri
    name
    id
    count
    link
    termTaxonomyId
    termGroupId
    databaseId
    description
    nodeType
    slug
    locale {
      locale
    }
  }

  fragment LatestPost on WpPost {
    title
    slug
  }

  {
    wp {
      ...GeneralSettings
    }

    featuredPost: allWpPost(
      sort: { fields: date, order: DESC }
      filter: {
        locale: { locale: { eq: "en_US" } }
        status: { eq: "publish" }
        isSticky: { eq: true }
      }
    ) {
      edges {
        node {
          ...previewCardQuery
        }
      }
    }

    latestPost: allWpPost(
      sort: { fields: date, order: DESC }
      limit: 1
      filter: { locale: { locale: { eq: "en_US" } }, status: { eq: "publish" } }
    ) {
      edges {
        node {
          ...LatestPost
        }
      }
    }

    allWpPost(
      sort: { fields: date, order: DESC }
      filter: { locale: { locale: { eq: "en_US" } }, status: { eq: "publish" } }
    ) {
      edges {
        node {
          ...previewCardQuery
        }
      }
    }

    allWpTag(filter: { locale: { locale: { eq: "en_US" } } }) {
      edges {
        node {
          ...homePageTag
        }
      }
    }

    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    contentfulNavigationBar(node_locale: { eq: "en-US" }) {
      ...ContentfulNavQuery
    }

    contentfulFooterV2(node_locale: { eq: "en-US" }) {
      ...ContentfulFooterQuery
    }
  }
`

export default IndexPage
